import { combineReducers } from 'redux';
import { Map } from 'immutable';

import biometricAuthenticationReducer, { BiometricAuthenticationState } from '../ducks/biometricAuthentication';
import developerDrawerReducer, { DeveloperDrawerState } from '../ducks/developerDrawer';
import gpsLocationReducer, { GPSLocationState } from '../ducks/gpsLocation';
import installDependentAppReducer, { InstallDependentAppState } from '../ducks/installDependentApp';
import imageInjectionReducer, { ImageInjectionState } from '../ducks/imageInjection';
import liveSessionManagerReducer, { LiveSessionManagerState } from '../ducks/liveSessionManager';
import mobileLogReducer from '../ducks/deviceLogs';
import mobileAppSelectionReducer, { MobileAppSelectionState } from '../ducks/mobileAppSelection';
import mobileSessionReducer from './mobileSessionReducer';
import presetsReducer, { PresetsState } from '../ducks/presets';
import rdcSessionReducer, { RdcSessionState } from '../ducks/rdcSession';
import realDeviceSelectionReducer from '../ducks/realDeviceSelection';
import recentAndSavedConfigsReducer from '../ducks/recentAndSavedConfigs';
import sessionCommonReducer, { SessionCommonState } from '../ducks/sessionCommon';
import switchAppVersionReducer, { SwitchAppVersionState } from '../ducks/switchAppVersion';
import testConfigurationReducer from '../ducks/testConfiguration';
import uploadToSdCardReducer, { UploadToSdCardState } from '../ducks/uploadToSdCard';

export interface GlobalState {
  apps: {
    manual: {
      biometricAuthentication: BiometricAuthenticationState;
      developerDrawer: DeveloperDrawerState;
      gpsLocation: GPSLocationState;
      installDependentApp: InstallDependentAppState;
      imageInjection: ImageInjectionState;
      liveSessionManager: LiveSessionManagerState;
      loading: boolean;
      mobileAppSelection: MobileAppSelectionState;
      presets: PresetsState;
      rdcSession: RdcSessionState;
      session: Map<string, unknown>; // TODO: type properly
      sessionCommon: SessionCommonState;
      switchAppVersion: SwitchAppVersionState;
      uploadToSdCard: UploadToSdCardState;
    }
  }
}

const manualReducer = combineReducers({
  biometricAuthentication: biometricAuthenticationReducer,
  developerDrawer: developerDrawerReducer,
  gpsLocation: gpsLocationReducer,
  installDependentApp: installDependentAppReducer,
  imageInjection: imageInjectionReducer,
  liveSessionManager: liveSessionManagerReducer,
  log: mobileLogReducer,
  mobileAppSelection: mobileAppSelectionReducer,
  presets: presetsReducer,
  realDeviceSelection: realDeviceSelectionReducer,
  recentAndSavedConfigs: recentAndSavedConfigsReducer,
  rdcSession: rdcSessionReducer,
  session: mobileSessionReducer,
  sessionCommon: sessionCommonReducer,
  switchAppVersion: switchAppVersionReducer,
  testConfiguration: testConfigurationReducer,
  uploadToSdCard: uploadToSdCardReducer,
});

export default manualReducer;
export type {
  InstallDependentAppState,
  MobileAppSelectionState,
  SwitchAppVersionState,
};
